export default {"src":"/_next/static/media/gem.08f33fa9.svg","height":20,"width":20};